import { i as p, r as h, s as g, x as r, e as u } from "./query-assigned-elements-96a4d233.mjs";
import { n as c } from "./property-9b6ea53b.mjs";
import { S as m } from "./index-19a5caf5.mjs";
import "./components/user-menu-item/index.js";
const f = `:host{--font-regular: "Circular Std Medium", Helvetica, Arial, sans-serif;--font-regular-italic: "Circular Std Medium Italic", Helvetica, Arial, sans-serif;--font-thin: "Circular Std Book", Helvetica, Arial, sans-serif;--font-thin-italic: "Circular Std Book Italic", Helvetica, Arial, sans-serif;--font-bold: "Circular Std Bold", Helvetica, Arial, sans-serif;--font-bold-italic: "Circular Std Bold Italic", Helvetica, Arial, sans-serif;font-size:16px;--fs-xxl: 40px;--fs-xl: 35px;--fs-l: 25px;--fs-m: 19px;--fs-s: 16px;--fs-xs: 14px;--padding-inline: 2em;--padding-block: 2em;--max-width-main-content: 500px;--max-width-menu: 350px;--height-top-menu: 5em;--width-side-menu: 22em;--max-width-search-menu: 550px}@media screen and (max-width: 390px){:host{--fs-xxl: 37px;--fs-xl: 30px;--fs-l: 25px;--fs-m: 18px;--fs-s: 16px;--fs-xs: 14px}}@media screen and (max-width: 1300px){:host{--padding-inline: 1.5em;--padding-block: 1.5em}}@media screen and (max-width: 500px){:host{--padding-inline: 1em;--padding-block: 1.5em}}h1,h2,h3,h4,h5{font-family:var(--font-bold);color:#31273e;margin-block:.5em}h1{font-size:var(--fs-xxl);line-height:1.2}h2{font-size:var(--fs-xl)}h3{font-size:var(--fs-l)}h4{font-size:var(--fs-m)}h5{font-size:var(--fs-s)}p,span,address{font-family:var(--font-thin);font-size:var(--fs-s);color:#919191;line-height:initial;padding:initial;line-height:1.5}a{font-size:1em;color:#00a3ff;text-decoration:underline;cursor:pointer}div{font-family:var(--font-thin);color:#919191;line-height:1}button{display:flex;align-items:center;gap:1.2em;padding:.6em 1.5em;border-radius:1.8em;font-size:1em;cursor:pointer;font-family:var(--font-regular);transition:all .2s ease-in-out;border:none}.gray-box{background-color:#f6f6f6;padding:1.5em;border-radius:.5em;border:1px solid #e0e0e0;text-align:center}.page-container{display:flex;flex-direction:column;height:100%;min-height:100svh;overflow-x:hidden;overflow-y:auto;margin:0;padding:0}.page-container .page-content{display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden;gap:3em;font-size:.9em;justify-self:center;align-self:center;flex:1;padding:var(--padding-block) var(--padding-inline)}.page-container .page-content h2{margin:0;text-align:center}.page-container .page-massage{color:#919191;background-color:#f5f5f5;max-width:var(--max-width-main-content);border-radius:1em;padding:1em var(--padding-inline);height:max-content}.page-container .page-massage>*{text-align:center}@media screen and (max-width: 500px){.page-container .page-massage{border-radius:0;max-width:initial;margin-inline:calc(var(--padding-inline) * -1)}}.page-container .page-illustration{width:100%;max-width:var(--max-width-main-content)}.page-container .page-illustration svg{width:100%;max-height:350px}.user-menu-modal{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.1em;padding-block:1.3em 1em;padding-inline:.8em;box-sizing:border-box;font-size:.9em;max-height:600px;width:100%;overflow-x:hidden}.header{display:flex;justify-content:space-between;align-items:center;width:100%}.sign-out-button{gap:.5em;color:#666;border:1px solid color-mix(in srgb,#666666 40%,#fff);background-color:transparent}.sign-out-button .text{font-size:1em;line-height:1;color:inherit}.sign-out-button svg{width:1.2em;height:1.2em;fill:currentColor}.sign-out-button:hover{background-color:#666;color:#fff}.close{display:flex;align-items:center;justify-content:center;padding:.6em;border-radius:.3em;background-color:transparent;cursor:pointer}.close svg{width:1em;height:1em;fill:var(--color-black)}.close :hover{background-color:#f3f3f3}.active-role{display:flex;flex-direction:column;align-items:center;gap:.8em}.active-role[data-role-type=tenant]{--role-color: #2f2489}.active-role[data-role-type=owner]{--role-color: #8fad2a}.active-role[data-role-type=employee]{--role-color: #663819}.active-role[data-role-type=manager]{--role-color: #000000}.active-role[data-role-type=vendor]{--role-color: #d27638}.active-role-selector{display:flex;flex-direction:column;align-items:center;gap:.5em;cursor:pointer}.active-role-selector .avatar-holder{position:relative;width:70px;height:70px;border-radius:50%;transition:all .2s ease-in-out;border:.2rem solid var(--role-color);font-size:1.15em}.active-role-selector .avatar-holder .goto-icon{position:absolute;bottom:-5px;right:-3px;color:#fff;background-color:var(--role-color);box-sizing:border-box;border:solid 4px #fff;width:30px;height:30px;border-radius:50%;display:flex;justify-content:center;align-items:center;transition:all .4s ease-in-out}.active-role-selector .avatar-holder .goto-icon svg{width:.9em;height:.9em;fill:#fff;transition:all .4s ease-in-out}.active-role-selector .role-type{color:#fff;background-color:var(--role-color);padding:.4em .9em;height:max-content;border-radius:1.2em;width:70px;text-align:center;text-transform:capitalize}.active-role-selector:hover .goto-icon{bottom:0;right:0;width:70px;height:70px}.active-role-selector:hover .goto-icon svg{width:1.8em;height:1.8em}.avatar{position:relative;top:50%;left:50%;transform:translate(-50%,-50%);width:90%;height:90%;border-radius:50%}.placeholder-avatar{background-color:#9b9b9b;display:flex;justify-content:center;align-items:center;color:#fff;font-size:1.7em}.display-name{font-family:var(--font-regular);font-size:1.2em;color:#666;padding-top:.3em;padding-bottom:.5em}.no-role-selected{font-family:var(--font-thin);font-size:1.8em;margin-block:1em .9em}.manage-roles{display:flex;flex-direction:column;align-items:center;gap:.5em;width:100%}.merge-account,.merge-account a{font-size:1em;text-align:center;margin-bottom:-2em}.alternate-button{background-color:transparent;color:#31273e;border:1px solid #31273e}.alternate-button:hover{background-color:#31273e;color:#fff}.roles-list{display:flex;flex-direction:column;gap:.7em;border-radius:2em;max-height:23em;min-height:2em;overflow-x:hidden;overflow-y:auto;margin-top:1.3em;padding:0;width:100%;box-sizing:border-box;margin-bottom:-.3em}.roles-list::-webkit-scrollbar{width:.5em}.roles-list::-webkit-scrollbar-track{background-color:color-mix(in srgb,#aaaaaa 0%,#fff);border-radius:1em}.roles-list::-webkit-scrollbar-thumb{background-color:color-mix(in srgb,#aaaaaa 90%,#fff);border:1px #fff solid;box-sizing:border-box;border-radius:1em}.roles-list::-webkit-scrollbar-thumb:hover{background-color:color-mix(in srgb,#aaaaaa 100%,#fff)}
`;
class v {
  constructor(a) {
    (this.host = a).addController(this);
  }
  getAppAndEnv() {
    const o = window.location.href.split("/")[2];
    let t = "homepage";
    switch (!0) {
      case o.includes("account."):
        t = "account";
        break;
      case o.includes("pro."):
        t = "pro-app";
        break;
      default:
        t = "homepage";
        break;
    }
    let n = "production";
    switch (!0) {
      case o.includes(".test"):
        n = "development";
        break;
      case o.includes("stage."):
      case o.includes(".webflow.io"):
        n = "stage";
        break;
      default:
        n = "production";
        break;
    }
    return { app: t, env: n };
  }
  hostConnected() {
  }
  hostDisconnected() {
  }
}
var b = Object.defineProperty, x = Object.getOwnPropertyDescriptor, l = (e, a, i, o) => {
  for (var t = o > 1 ? void 0 : o ? x(a, i) : a, n = e.length - 1, d; n >= 0; n--)
    (d = e[n]) && (t = (o ? d(a, i, t) : d(t)) || t);
  return o && t && b(a, i, t), t;
};
let s = class extends g {
  constructor() {
    super(...arguments), this.rolesData = [], this.activeRoleId = void 0, this.selectRoleLoading = !1, this.getRolesLoading = !1, this.selectedRoleId = null, this.env = new v(this).getAppAndEnv().env, this.component = {
      header: () => r`
            <button class="sign-out-button" @click=${this.handle.signOut}>
               ${m.form.signOut}
               <span class="text">Sign Out</span>
            </button>
            <button class="close" @click=${this.handle.closeModal}>
               <span class="icon"> ${m.form.close} </span>
            </button>
         `,
      activeRole: () => {
        var e, a, i, o, t;
        return !this.getRolesLoading && this.rolesData.length < 1 ? null : this.method.getActiveRole() ? r`
            <div class="active-role-selector" @click=${this.handle.gotoCurrentActiveRole}>
               <div class="avatar-holder">
                  ${(e = this.method.getActiveRole()) != null && e.avatarImage ? r`<img
                          class="avatar"
                          src=${(a = this.method.getActiveRole()) == null ? void 0 : a.avatarImage}
                       />` : r`<div class="avatar placeholder-avatar">
                          ${this.method.getInitials(
          (i = this.method.getActiveRole()) == null ? void 0 : i.displayName
        )}
                       </div>`}
                  <span class="goto-icon">${m.form.goto}</span>
               </div>
               <div class="role-type">${(o = this.method.getActiveRole()) == null ? void 0 : o.role}</div>
            </div>
            <div class="display-name">${(t = this.method.getActiveRole()) == null ? void 0 : t.displayName}</div>
         ` : r` <p class="no-role-selected">Please select a role</p> `;
      },
      manageRoles: () => !this.getRolesLoading && this.rolesData.length < 1 ? r`
               <p class="gray-box">
                  You do not have a role assigned to your user account. In order to access
                  a RentPost portal, you must have a role. You can add one by clicking the
                  button below.
               </p>
               <button class="alternate-button" @click=${this.handle.addRole}>
                  Add Role
               </button>
               <p class="merge-account">
                  If you have another account with associated roles, you can also
                  <a class="link" @click=${this.handle.manageRoles}>
                     merge your user accounts.
                  </a>
               </p>
            ` : r`
            <button class="alternate-button" @click=${this.handle.manageAccount}>
               Manage your Account
            </button>
         `,
      roleList: () => !this.getRolesLoading && this.method.getRolesToSelectFrom().length < 1 ? null : this.getRolesLoading ? r`
               <div className="user-item-skelton"></div>
               <div className="user-item-skelton"></div>
               <div className="user-item-skelton"></div>
            ` : this.method.getRolesToSelectFrom().map((e) => r`
               <user-menu-item
                  .roleData=${e.staticProps}
                  ?loading=${this.selectedRoleId === e.staticProps.roleId && this.selectRoleLoading}
                  ?hide=${!!this.selectedRoleId && this.selectedRoleId !== e.staticProps.roleId}
                  @selectRole=${this.handle.selectRole}
               >
               </user-menu-item>
            `)
    }, this.method = {
      getActiveRole: () => {
        const e = this.rolesData.find((a) => a.staticProps.roleId === this.activeRoleId);
        if (e)
          return {
            displayName: e == null ? void 0 : e.staticProps.displayName,
            role: e == null ? void 0 : e.staticProps.role,
            avatarImage: e == null ? void 0 : e.staticProps.avatarImage
          };
      },
      getRolesToSelectFrom: () => this.rolesData.filter(
        (e) => e.staticProps.roleId !== this.activeRoleId
      ),
      getInitials: (e) => {
        const [a, i] = e.split(" "), o = a[0].toUpperCase(), t = i ? i[0].toUpperCase() : "";
        return `${o}${t}`;
      }
    }, this.handle = {
      closeModal: () => {
        this.dispatchEvent(new CustomEvent("closeModal"));
      },
      signOut: () => {
        this.dispatchEvent(new CustomEvent("signOut"));
      },
      manageRoles: () => {
        this.dispatchEvent(new CustomEvent("manageRoles"));
      },
      selectRole: (e) => {
        this.dispatchEvent(
          new CustomEvent("selectRole", {
            detail: {
              roleId: e.detail.roleId
            }
          })
        );
      },
      addRole: () => {
        this.dispatchEvent(new CustomEvent("addRole"));
      },
      manageAccount: () => {
        this.dispatchEvent(new CustomEvent("manageAccount"));
      },
      gotoCurrentActiveRole: () => {
        var i;
        const e = (i = this.method.getActiveRole()) == null ? void 0 : i.role, a = () => {
          let o = "";
          switch (this.env) {
            case "development":
              o = "https://pro.rentpost.test";
              break;
            case "stage":
              o = "https://pro.stage.rentpost.com";
              break;
            default:
              o = "https://pro.rentpost.com";
              break;
          }
          let t = "";
          switch (e) {
            case "tenant":
              t = "myrent";
              break;
            case "manager":
              t = "mypost";
              break;
            case "owner":
              t = "myplace";
              break;
            case "employee":
              t = "control";
              break;
          }
          return `${o}/${t}`;
        };
        this.handle.closeModal(), location.assign(a());
      }
    };
  }
  // -------------
  // Render Method
  // -------------
  render() {
    var e;
    return r`
         <div class="user-menu-modal">
            <div class="header">${this.component.header()}</div>
            <div
               class="active-role"
               data-role-type=${((e = this.method.getActiveRole()) == null ? void 0 : e.role) || ""}
            >
               ${this.component.activeRole()}
            </div>
            <div class="manage-roles">${this.component.manageRoles()}</div>
            <div class="roles-list">${this.component.roleList()}</div>
         </div>
      `;
  }
};
s.styles = p`
      ${h(f)}
   `;
l([
  c({ type: Array })
], s.prototype, "rolesData", 2);
l([
  c()
], s.prototype, "activeRoleId", 2);
l([
  c({ type: Boolean })
], s.prototype, "selectRoleLoading", 2);
l([
  c({ type: Boolean })
], s.prototype, "getRolesLoading", 2);
l([
  c({ type: String })
], s.prototype, "selectedRoleId", 2);
s = l([
  u("user-menu-modal")
], s);
export {
  v as G,
  s as U
};
//# sourceMappingURL=index-b410f145.mjs.map
